import { ItemID } from "types/common";

import React from "react";

import { useGetTaxonomyItemsInBatches } from "modules/MatchingModule/api/useGetTaxonomyItemsInBatches";

// One small GET /item/?ids=<brand id>, cached per id, instead of loading the brand's whole class list
export const useBrandName = (brandId: ItemID) => {
  const brandIds = React.useMemo(() => (brandId ? [brandId] : []), [brandId]);
  const { items } = useGetTaxonomyItemsInBatches(brandIds, !!brandId);

  return items[0]?.name || "";
};
